import React from 'react';

import { PageSizeContainer } from '../PageSizeContainer';

export const SettingsThirdColumn = () => {
  return (
    <>
      <div data-cy="user-settings-language-container" className="mb-40">
        <h4 className="mb-10">Page Size</h4>
        <PageSizeContainer />
      </div>
    </>
  );
};
